import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { cn } from '../lib/cn.js';
const STORAGE_KEY = 'pathara.theme';
function systemPrefersDark() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
}
export function applyTheme(choice) {
    const dark = choice === 'dark' || (choice === 'system' && systemPrefersDark());
    document.documentElement.dataset['theme'] = dark ? 'dark' : 'light';
}
export function readStoredTheme() {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === 'light' || stored === 'dark' || stored === 'system' ? stored : 'system';
}
const OPTIONS = [
    { value: 'light', label: 'Light', short: 'Light', glyph: '☀' },
    { value: 'system', label: 'Follow the system', short: 'Auto', glyph: '◐' },
    { value: 'dark', label: 'Dark', short: 'Dark', glyph: '☾' },
];
export function ThemeToggle({ className }) {
    // Re-rendered whenever the machine's appearance changes, so the label below
    // can say what "follow the system" resolves to right now.
    const [systemIsDark, setSystemIsDark] = useState(systemPrefersDark);
    // Read once, at first render, rather than in an effect: setting state from
    // an effect means rendering the wrong answer and then correcting it, which
    // is a visible flicker on the one control whose whole job is how things look.
    const [choice, setChoice] = useState(readStoredTheme);
    // Following the system means following it as it changes, not only at boot.
    useEffect(() => {
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        const onChange = () => {
            setSystemIsDark(media.matches);
            if (choice === 'system')
                applyTheme('system');
        };
        media.addEventListener('change', onChange);
        return () => media.removeEventListener('change', onChange);
    }, [choice]);
    const pick = (next) => {
        setChoice(next);
        window.localStorage.setItem(STORAGE_KEY, next);
        applyTheme(next);
    };
    const resolved = choice === 'system' ? (systemIsDark ? 'dark' : 'light') : choice;
    return (_jsxs("div", { className: cn('flex flex-col gap-1', className), children: [_jsx("span", { className: "text-2xs uppercase tracking-[0.12em] text-white/35", children: choice === 'system' ? `Auto, now ${resolved}` : 'Appearance' }), _jsx("div", { role: "radiogroup", "aria-label": "Appearance", className: "flex rounded-[var(--radius-control)] bg-black/25 p-0.5", children: OPTIONS.map((option) => (_jsx("button", { type: "button", role: "radio", "aria-checked": choice === option.value, "aria-label": option.label, title: option.label, onClick: () => pick(option.value), className: cn('flex flex-1 items-center justify-center rounded-[calc(var(--radius-control)-0.2rem)]', 'px-1 py-1 text-xs leading-none transition-[background-color,color]', 'duration-[var(--duration-quick)]', choice === option.value
                        ? 'bg-white/[0.14] text-white shadow-[inset_0_1px_0_rgb(255_255_255/0.12)]'
                        : 'text-white/40 hover:bg-white/[0.06] hover:text-white/80'), children: _jsx("span", { "aria-hidden": "true", children: option.glyph }) }, option.value))) })] }));
}
//# sourceMappingURL=theme-toggle.js.map